import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { getZählerForMieter } from "../api";
import ZählerComponente from "../components/Zählercomponente";
import backgroundImage from '../assets/LOGO.png';
import Animation from "../components/Animation";

function MieterDashboard() {
    const { mieterId } = useParams();
    const mieterName = localStorage.getItem("username")
    const [loading, isLoading] = useState(false)
    const [zaehlerList, setZaehlerList] = useState([]);

  // Fetch data from API
  const fetchZaehlerData = async () => {
    if (mieterId) {
      getZählerForMieter(mieterId).then(setZaehlerList).catch(console.error).finally(isLoading(false));
    }
  };

  useEffect(() => {
    fetchZaehlerData();
  }, []);

    return (
      <div style={{ position: 'relative', minHeight: '100vh' }}>
      <img
        src={backgroundImage}
        alt="Logo"
        style={{
          position: 'fixed',
          top: '30px',
          left: '50%',
          transform: 'translateX(-50%)',
          width: '50%',
          zIndex: 0,
          opacity: 0.6,
          pointerEvents: 'none',
        }}
      />
    
      <div style={{ position: "relative", zIndex: 1, padding: "2rem" }}>
        <h1>Mieter Dashboard</h1>
        <h2>Willkommen {mieterName}.</h2>
        <p>Zur Vereinfachung des jährlichen Wasserzählerablesens gibt es nun diese anschauliche Plattform. Viel Vergnügen beim Eintragen.</p>
    
        <div className="navbar" style={{ marginBottom: "1.5rem" }}>
          <Link to={`/mieter/${mieterId}/einstellungen`} style={{ marginRight: "1rem" }}>
            Mieter-Daten ändern
          </Link>
          <Link to={`/mieter/${mieterId}/betriebskostenabrechnungen`}>
            Betriebskostenabrechnungen
          </Link>
        </div>
    
        <h2>Deine Zähler</h2>
        {zaehlerList.length === 0 ? (
          <p>Keine Zähler gefunden.</p>
        ) : (
          zaehlerList.map((zaehler) => (
            <ZählerComponente key={zaehler.id} mieter={true} zaehler={zaehler} refreshData={fetchZaehlerData} />
          ))
        )}
      </div>
      <Animation loading={loading}/>
    </div>
    );
}

export default MieterDashboard;
